import { createContext, useContext, useEffect, useState } from "react";

const ContextProyect = createContext();

export const ContextProyectProvider = ({ children }) => {
    const [ reloadCourse, setReloadCourse ] = useState(null);
    const [ reloadProgress, setReloadProgress ] = useState(null);

    return (
        <ContextProyect.Provider value={{ reloadCourse, setReloadCourse, reloadProgress, setReloadProgress}}>
            {children}
        </ContextProyect.Provider>
    );
};

export const useContextProyect = () => {
    return useContext(ContextProyect);
};
